import { store } from 'app_storage/redux-storage'
import { DefaultRoutingService } from 'app_services/routingService';

type TypeValidatorSetCurrentHierarchy = 'create_survey'

interface IOptionsSetCurrentHierarchy {
  validator?: TypeValidatorSetCurrentHierarchy
}

export interface IQueryParamsURL{
  survey?: string
  config?: string
  token?: string
  redirect?: string
  section?: string
  username?: string
}

class RouterService {

  private storeObject = store
  private routingService: DefaultRoutingService

  constructor() {
    this.routingService = new DefaultRoutingService()
  }

  public getRouteFromObject = (_object: Object, screen?: TypeValidatorSetCurrentHierarchy, options?: {editor?: boolean, idQuestion?: string}) => {

    // @INFO Obtener las propiedades definidas
    const params = Object.keys(_object).reduce((accum: Object, item: string) => {
      // @ts-ignore
      if(_object[item]){
        accum = {
          ...accum,
          // @ts-ignore
          [item]: _object[item]
        }
      }
      return accum
    }, {})

    // @INFO Formar la ruta con las propiedades del objeto
    const keys = Object.keys(params)
    let route = keys.reduce((acum: string, item: string, idx: number) => {
      if (idx === keys.length - 1) {
        // @ts-ignore
        acum = `${acum}${item}=${params[item]}`
      } else {
        // @ts-ignore
        acum = `${acum}${item}=${params[item]}&`
      }
      return acum
    }, '')
    route = screen ? `/${screen}/${route}` : `/${route}`

    route = this.routingService.getSecurePath(route)

    return route
  }

  /**
   * @INFO Obtener los parámetros de una ruta
   * @param route
   */
  public getParamsURL = () => {
    // @INFO Agarrar el ultimo "/"
    const _route = window.location.href
    const route = _route.split('/')[_route.split('/').length - 1]
    let newRoute = ''
    if(route.includes('=')){
      if(!route.includes('?')){
        newRoute = `?${route}`
      }else{
        newRoute = window.location.search
      }
    }else{
      newRoute = window.location.search
    }
    const query = new URLSearchParams(newRoute)
    return query
  }

  /**
   * @INFO Obtener el objeto con los parámetros en la url
   * @param _query
   * @returns
   */
  public getParamsURLObject = (_query?: URLSearchParams) => {
    const paramsURL = _query ? _query : this.getParamsURL()
    let result: IQueryParamsURL = {}
    // @ts-ignore
    for(let key of paramsURL.keys()){
      if(paramsURL.get(key)){
        result = {
          ...result,
          [key]: paramsURL.get(key)
        }
      }
    }
    return result
  }

}

export default RouterService
